export const getEmailTemplatesApi = '/api/email-templates'
export const postEmailTemplateApi = '/api/email-templates'
export const getEmailTemplateByIdApi = '/api/email-templates/:id'
export const getGetEmailTemplateByIdApi = (id) => `/api/email-templates/${id}`
export const patchEmailTemplateApi = '/api/email-templates/:id'
export const getPatchEmailTemplateApi = (id) => `/api/email-templates/${id}`
export const deleteEmailTemplateApi = '/api/email-templates/:id'
export const getDeleteEmailTemplateApi = (id) => `/api/email-templates/${id}`